// Sipariş formu, proforma ve defterde ortak ürün sıralaması:
// 1. Özel Baskı, 2. Metrelik Ebat, 3. Esmaül Hüsna, 4. Büyük Ebat, 5. Makine Baskıları, 6. Yan Ürünler.
// Grup içinde ürünler veritabanı sırasına (ürün id) göre dizilir. (Backend'deki urun_sira_anahtari ile aynı)
const KATEGORI_SIRASI = { 'Metrelik Ebat': 1, 'Esmaül Hüsna': 2, 'Büyük Ebat': 3, 'Yan Ürünler': 5 };

export const urunSiraGrubu = (urun) => {
    if (urun.urun_tipi === 'Özel Baskı') return 0;
    if (urun.isMakine || urun.urun_tipi === 'Makine Baskısı') return 4;
    return KATEGORI_SIRASI[urun.kategori] ?? 6;
};

export const urunleriSirala = (urunler) =>
    [...(urunler || [])]
        .map((urun, index) => ({ urun, index }))
        .sort((a, b) =>
            (urunSiraGrubu(a.urun) - urunSiraGrubu(b.urun)) ||
            ((a.urun.id ?? 0) - (b.urun.id ?? 0)) ||
            (a.index - b.index))
        .map(({ urun }) => urun);
